import Affiliations from './AffiliationsContext'
import AffiliationLabel from './AffiliationLabel'
import affiliationsHooks from './hooks'

export { affiliationsHooks, AffiliationLabel }
export default Affiliations